import { render, staticRenderFns } from "./IllnessFormDialog.vue?vue&type=template&id=9daf7608"
import script from "./IllnessFormDialog.vue?vue&type=script&lang=js"
export * from "./IllnessFormDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports